/**
 * @file コンポーネント：フル動画ページタイムラインシェーマ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル設定読み込み
import {
    StyledList,
    StyledListImage,
    StyledListItem,
    StyledPopupSchemaButton,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledList>
            {props.listSchema.map((schema, index) => (
                <StyledListItem key={"schema-" + index}>
                    <StyledListImage
                        alt={schema.fileName}
                        src={schema.fileUrl}
                    />
                    <StyledPopupSchemaButton
                        data-index={index}
                        href="#"
                        onClick={(e) => props.fnOpenPopupSchema(e)}
                        onMouseOut={() =>
                            props.setIsMouseOverPopupSchemaButton(false)
                        }
                        onMouseOver={() =>
                            props.setIsMouseOverPopupSchemaButton(true)
                        }
                    >
                        <i className="fas fa-clone"></i>
                    </StyledPopupSchemaButton>
                </StyledListItem>
            ))}
        </StyledList>
    );
};
